import { render, staticRenderFns } from "./delete-modal.vue?vue&type=template&id=e5a2b654"
import script from "./delete-modal.vue?vue&type=script&lang=js"
export * from "./delete-modal.vue?vue&type=script&lang=js"
import style0 from "./delete-modal.vue?vue&type=style&index=0&id=e5a2b654&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports